import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import CastingService from "../../../services/CastingService";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2

const CastingReport = () => {
  const [open, setOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [open2, setOpen2] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("all");
  const [totalcount, setTotalCount] = useState(0);

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await CastingService.CastingReport({ fromDate, toDate, status });
      setReportData(response.data);
      setTotalCount(response.count);
      Swal.fire({
        icon: "success",
        title: "Report Generated",
        text: `Report Successfully Generated for the Selected Date Range.`,
      });
    } catch (error) {
      console.error("Error fetching report data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch report data. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  const filteredData = reportData.filter((item) => {
    const search = searchQuery.toLowerCase();
    return (
      String(item?.RequestType || "").toLowerCase().includes(search) ||
      String(item?.storeName || "").toLowerCase().includes(search) ||
      String(item?.RequestNo || "").toLowerCase().includes(search) ||
      String(item?.masterItem?.partNo || "").toLowerCase().includes(search) ||
      String(item?.masterItem?.description || "").toLowerCase().includes(search)
    );
  });


  const downloadExcel = () => {
    if (reportData.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Data",
        text: "No data available to download.",
      });
      return;
    }

    const formattedData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Request Type": item?.RequestType || "",
      "Store": item?.storeName || "",
      "Date": item?.createdAt?.split("T")[0] || "",
      "Request No": item?.RequestNo || "",
      "Part No": item?.masterItem?.partNo || "",
      "Description": item?.masterItem?.description || "",
      "Unit": item?.unitName || "",
      "Received Qty": item?.RequestType === "MRV" ? item?.qtyRecived : "NA",
      "Approved Qty": item?.approveQty || "",
      "Casting Qty": item?.castingQty || "",
      "Total Received Old": item?.RequestType === "MRV" ? item?.totalRecive?.old || "Not available" : "NA",
      "Total Received New": item?.RequestType === "MRV" ? item?.totalRecive?.new || "Not available" : "NA",
      "Current Stock Old": item?.currentStock?.old || "Not available",
      "Current Stock New": item?.currentStock?.new || "Not available",
      "MIV Old": item?.RequestType === "MIV" ? item?.totalMiv?.old || "Not available" : "NA",
      "MIV New": item?.RequestType === "MIV" ? item?.totalMiv?.new || "Not available" : "NA",
      "Status": item?.status || "",
      "User": item?.user?.name || "",
      "User Email": item?.user?.email || "",
    }));



    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const fileName = `Casting_Report_${date}_${time}.xlsx`;

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Casting Report");

    XLSX.writeFile(workbook, fileName);
    Swal.fire({
      icon: "success",
      title: "Download Successful",
      text: `File "${fileName}" has been downloaded successfully.`,
    });
  };
  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };


  return (
    <>
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fas fa-filter me-2"></i>Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                onClick={() => setOpen(!open)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">From</label>
                    <input
                      type="date"
                      name="fromDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">To</label>
                    <input
                      type="date"
                      name="toDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-4 col-xxl-4">
                    <label className="ms-2">Search</label>
                    <button
                      className="form-control btn btn-primary"
                      onClick={fetchReport}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Generate Report"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>

        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fa fa-list me-2" aria-hidden="true"></i>Casting Report
              <span className="badge bg-orange ms-2">{totalcount}</span>
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                onClick={() => setOpen2(!open2)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                {!loading && reportData?.length > 0 && (
                  <div className="row mb-2">
                    <div className="col-12">
                      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <input
                          className="form-control"
                          style={{ width: "500px" }}
                          id="searchInput"
                          placeholder="Search by Request Type, Store, Request No, Part No or Description"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <p
                          onClick={downloadExcel}
                          className="btn btn-rounded btn-md btn-primary mb-0"
                        >
                          <i className="las la-download scale5 me-2"></i> Download Report
                        </p>
                      </div>
                    </div>
                  </div>
                )}


                <div className="scrolltable">
                  <table className="table table-bordered table-striped">
                    <thead className="sticky-table-header">
                      <tr>
                        <th>S.No</th>
                        <th>Request Type</th>
                        <th>Store</th>
                        <th>Date</th>
                        <th>Request No</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th>Received Qty</th>
                        <th>Apporved Qty</th>
                        <th>Casting Qty</th>
                        <th>Total Received Old</th>
                        <th>Total Received New</th>
                        <th>Current Stock Old</th>
                        <th>Current Stock New</th>
                        <th>Miv Old</th>
                        <th>Miv New</th>
                        <th>Status</th>
                        <th>User</th>
                        <th>User Email</th>

                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.RequestType}</td>
                            <td className="scrollable-description">{item?.storeName}</td>
                            <td>{item?.createdAt ? formatDate(item.createdAt) : ''}</td>
                            <td>{item?.RequestNo}</td>
                            <td>{item?.masterItem.partNo}</td>
                            <td className="scrollable-description">{item?.masterItem?.description}</td>
                            <td>{item?.unitName}</td>
                            <td>{item?.RequestType === "MRV" ? item?.qtyRecived : "NA"}</td>
                            <td>{item?.approveQty}</td>
                            <td>{item?.castingQty}</td>
                            <td>{item?.RequestType === "MRV" ? item?.totalRecive?.old || 'Not avaiable' : "NA"}</td>
                            <td>{item?.RequestType === "MRV" ? item?.totalRecive?.new || 'Not avaiable' : "NA"}</td>
                            <td>{item?.currentStock?.old || 'Not avaiable'}</td>
                            <td>{item?.currentStock?.new || 'Not avaiable'}</td>
                            <td>{item?.RequestType === "MIV" ? item?.totalMiv?.old || 'Not avaiable' : "NA"}</td>
                            <td>{item?.RequestType === "MIV" ? item?.totalMiv?.new || 'Not avaiable' : "NA"}</td>
                            <td>{item?.status}</td>
                            <td>{item?.user.name}</td>
                            <td>{item?.user?.email}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="14" className="text-center">
                            No data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default CastingReport;
